import { IFormInstance } from '@/components';
import { TSelectOptions } from '@/ui';

export enum DeliverySettingsFormFields {
  FREE_DELIVERY = 'freeDelivery',
  MIN_ORDER_AMOUNT = 'minimalOrderAmount',
  EXCLUDED_STATES_USA = 'excludedStatesUS',
  EXCLUDED_STATES_CANADA = 'excludedStatesCA',
  POPUP_TITLE = 'popupTitle',
  POPUP_DESCRIPTION = 'popupDescription',
  UPS_DELIVERY = 'upsDelivery',
  PRICE = 'price',
  IS_ENABLED = 'isEnabled',
}

export type TDeliverySettingsFormValues = {
  [DeliverySettingsFormFields.FREE_DELIVERY]: {
    [DeliverySettingsFormFields.IS_ENABLED]: boolean;
    [DeliverySettingsFormFields.MIN_ORDER_AMOUNT]: number;
    [DeliverySettingsFormFields.EXCLUDED_STATES_USA]: string[];
    [DeliverySettingsFormFields.EXCLUDED_STATES_CANADA]: string[];
    [DeliverySettingsFormFields.POPUP_TITLE]: string;
    [DeliverySettingsFormFields.POPUP_DESCRIPTION]: string;
  };
  [DeliverySettingsFormFields.UPS_DELIVERY]: {
    [DeliverySettingsFormFields.IS_ENABLED]: boolean;
    [DeliverySettingsFormFields.PRICE]: number;
    [DeliverySettingsFormFields.EXCLUDED_STATES_USA]: string[];
    [DeliverySettingsFormFields.EXCLUDED_STATES_CANADA]: string[];
  };
};

export type TDeliverySettingsFormSectionProps = {
  formInstance: IFormInstance;
  americanStates: TSelectOptions<string>;
  canadianStates: TSelectOptions<string>;
};
